export const mockData = {
  company: {
    name: "KFZ-Sachverständigenbüro Rinno",
    slogan: "Ihr Starker Partner im Schadenfall",
    certification: "Geprüft nach VFK e.V.",
    address: {
      street: "Holzschuherstraße 42",
      city: "90439 Nürnberg",
      email: "info@sv-rinno.de",
      phone: "+49 176 62168132",
      whatsapp: "https://wa.me/4917662168132?text=Guten%20Tag,%0Aich%20interessiere%20mich%20für%20ein%20Kfz-Gutachten%20und%20hätte%20dazu%20ein%20paar%20Fragen.%20Ich%20freue%20mich%20über%20Ihre%20Rückmeldung",
      hours: "Mo–Fr: 09:00–18:00 Uhr\nSa: 10:00–16:00 Uhr\nSo: nach Vereinbarung"
    }
  },
  
  services: [
    {
      title: "Schadengutachten",
      description: "Unabhängige Bewertung von Fahrzeugschäden",
      benefits: ["Schnelle Besichtigung vor Ort", "Anerkannt bei Versicherern", "Objektive Bewertung"]
    },
    {
      title: "Beweissicherung",
      description: "Professionelle Dokumentation für rechtliche Verfahren",
      benefits: ["Gerichtsfeste Dokumentation", "Detaillierte Fotodokumentation", "Zeugenvernehmung"]
    },
    {
      title: "Kostenvoranschlag-Prüfung",
      description: "Überprüfung von Reparaturkosten auf Angemessenheit",
      benefits: ["Kostentransparenz", "Vermeidung überhöhter Kosten", "Fachgerechte Bewertung"]
    },
    {
      title: "Wertgutachten",
      description: "Ermittlung des aktuellen Fahrzeugwerts",
      benefits: ["Marktgerechte Bewertung", "Für Versicherung & Verkauf", "Detaillierte Dokumentation"]
    },
    {
      title: "Restwertermittlung",
      description: "Bestimmung des Restwerts nach Totalschaden",
      benefits: ["Maximale Entschädigung", "Fundierte Argumentation", "Schnelle Abwicklung"]
    },
    {
      title: "Unfallrekonstruktion",
      description: "Technische Analyse des Unfallhergangs",
      benefits: ["Wissenschaftlich fundiert", "Für Haftungsklärung", "Gerichtsverwertbar"]
    }
  ],
  
  process: [
    {
      step: 1,
      title: "Kontaktaufnahme",
      description: "Telefonisch, per E-Mail oder über das Online-Formular – schnell und unkompliziert."
    },
    {
      step: 2,
      title: "Schadensanalyse",
      description: "Vor-Ort-Termin mit Prüfung und detaillierter Aufnahme des Schadens."
    },
    {
      step: 3,
      title: "Gutachtenerstellung",
      description: "Erstellung des professionellen Gutachtens mit allen relevanten Daten und Bildern."
    },
    {
      step: 4,
      title: "Unterstützung bei der Regulierung",
      description: "Begleitung bei der Schadensabwicklung mit Versicherungen und Kooperation mit Rechtsanwälten."
    }
  ],
  
  testimonials: [
    {
      name: "Michael R.",
      location: "München",
      service: "Schadengutachten",
      text: "Sehr professionelle und schnelle Abwicklung. Das Gutachten war detailliert und wurde von der Versicherung anstandslos akzeptiert."
    },
    {
      name: "Sandra K.",
      location: "Hamburg",
      service: "Wertgutachten",
      text: "Kompetente Beratung und faire Bewertung meines Fahrzeugs. Kann ich nur weiterempfehlen."
    },
    {
      name: "Thomas B.",
      location: "Berlin",
      service: "Unfallrekonstruktion",
      text: "Dank der präzisen Unfallanalyse konnte die Schuldfrage eindeutig geklärt werden. Exzellente Arbeit!"
    },
    {
      name: "Julia M.",
      location: "Frankfurt",
      service: "Restwertermittlung",
      text: "Nach dem Totalschaden erhielt ich dank des Gutachtens eine angemessene Entschädigung."
    }
  ],
  
  certificates: [
    {
      title: "VFK e.V. Zertifizierung",
      description: "Geprüfter Sachverständiger nach den Standards des Verbandes für Kraftfahrzeug-Sachverständige"
    },
    {
      title: "TÜV-Qualifikation",
      description: "Berechtigung zur Durchführung von Hauptuntersuchungen und Gutachten"
    },
    {
      title: "Weiterbildungszertifikat",
      description: "Regelmäßige Fortbildungen in aktueller Fahrzeugtechnik und Schadensanalyse"
    }
  ],
  
  aboutMe: {
    name: "Sachverständiger Rinno",
    experience: "Über 15 Jahre Erfahrung",
    qualifications: [
      "Staatlich anerkannter KFZ-Sachverständiger",
      "Mitglied im VFK e.V.",
      "TÜV-geprüfter Gutachter",
      "Spezialist für Unfallanalytik"
    ],
    description: "Als unabhängiger KFZ-Sachverständiger stehe ich für objektive und fundierte Gutachten. Meine langjährige Erfahrung und kontinuierliche Weiterbildung garantieren höchste Qualitätsstandards bei der Schadensbeurteilung."
  },
  
  images: {
    hero: "https://images.unsplash.com/photo-1642276075121-3ac7d959a9f0",
    aboutMe: "https://images.unsplash.com/photo-1560250097-0b93528c311a",
    damage1: "https://images.unsplash.com/photo-1591497108596-436c1a1a5c8e",
    expertise: "https://images.pexels.com/photos/2244746/pexels-photo-2244746.jpeg",
    assessment: "https://images.pexels.com/photos/943930/pexels-photo-943930.jpeg"
  },
  
  bookingsPlaceholder: "BOOKINGS_EMBED_URL_PLATZHALTER"
};